import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,ControlLabel,InputGroup,Form,FormGroup,Row,Col,FormControl,Modal,OverlayTrigger,Popover,Tooltip} from 'react-bootstrap'
import Select from 'react-select'
import FontAwsome from 'react-fontawesome'
import DatePicker from '../../component/element/DatePicker'
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup'
import InsurerPageModal from '../insurer/InsurerPageModal'
import GenDocStore from 'stores/GenDocStore'
// import AutopartStore from '../../stores/AutopartStore'
import InputNumber from 'rc-input-number'
import IframeModal from '../../component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import CKAutocomplete from 'component/element/CKAutocomplete'
import './Doc.css'
import WorkdocStore from 'stores/WorkdocStore';
import InvoiceModal from './InvoiceModal'
import POModal from './POModal'
import TaxinvoiceModal from './TaxinvoiceModal'
import PurchaseOrderDoc from '../po/PurchaseOrderDoc'
import SupplierPageModal from '../po/SupplierPageModal'
import { Checkbox, Radio } from 'react-icheck'
import _ from 'lodash'
import $ from 'jquery'
import DNDRowItem from '../ssp/RowItem'
var NotificationSystem = require('react-notification-system');
class GeneralDoc extends Component {

  constructor(props) {
    super(props)

    this.state = {
			data:{doc:{},itemlist:[]},
			defaultVat:'no',
			defaultVatDeduct:0,
			vatDeduct:0.00,
    	totalPayment:0.00,
    	hideTr:'none',
    	styleBBR:'bbr-b',
    	styleBR:'br-b',
			show:false,
			loading:false,
			docNo:'',
			showDelConfirm:false,
			reasonList:[],
			showTaxList:false,
			taxinvoice_lists:[],
			check_taxinvoice_lists:[],
			isCheckAll:false,
			showInvoiceList:false,
			showPOList:false,
			showPull:false,
			pullType:'',
			showInsurer:false,
			customerType:'',
			showSelectCustomerType:false,
			pdf_template:{},
			showTable:true,
			can_drag:false,
			darg_id:null,
			showSup:false
		}
  }

	componentDidMount(){
		this._notificationSystem = this.refs.notificationSystem
		$('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
	}

	componentWillReceiveProps(newProps) {
		if (newProps.show&&newProps.show!==this.props.show) {
			this.loadReasonList()
		}
	}

	loadReasonList() {
		WorkdocStore.loadCreditNoteReason((result)=>{
			let lists = []
			lists = result.data.map((item,index)=>{
				return {label:item.Name,value:item.Value}
			})
			this.setState({reasonList:lists})
		})
	}

	loadNewDoc(callback) {
		let {data,docNo,defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR} = this.state
    this.setState({loading:true})
    GenDocStore.newDoc(this.props.docType,this.props.docSName,(result)=>{       
			data = Object.assign({itemlist:[]}, result.data)
			data.doc = Object.assign({customer_name:'',customer_address:'',customer_tax:'',work_no:'',car:'',withholdamount:'0',withholdpercentage:'0',vat:'0'}, data.doc)
			if (this.props.docType==='deliveryslip')
				docNo = result.data.doc.deliveryslip_no
			else if (this.props.docType==='tempdeliverynote')
				docNo = result.data.doc.Tempdeliverynote_no
			else if (this.props.docType==='receiptvoucher')
				docNo = result.data.doc.receiptvoucher_no		
			else if (this.props.docType==='paymentvoucher')
				docNo = result.data.doc.paymentvoucher_no		
			
			defaultVat = (data.doc.vat_type==='VAT_EXCLUDE'?'out':data.doc.vat_type==='VAT_INCLUDE'||typeof data.doc.vat_type==='undefined'?'in':'no')	
			defaultVatDeduct = data.doc.withholdpercentage===undefined?'0':data.doc.withholdpercentage
			vatDeduct = data.doc.withholdamount
			// hideTr = 'none'
			hideTr = (data.doc.withholdpercentage>0?'':'none')
    	styleBBR = 'bbr-b'
			styleBR = 'br-b'
			this.setState({data:data},()=>{
				data.itemlist = this.sortRowIndex(data.itemlist)
				this.setState({loading:false,docNo:docNo,data:data,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})
				if (callback!==undefined)
					callback(result.data.doc)
			})
    })
	}

	loadInvoiceStatusNewDoc(docNo) {
		let {data,defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR} = this.state
    this.setState({loading:true})
    GenDocStore.newDocInvoiceStatus(this.props.docType,this.props.docSName,docNo,this.props.invoiceStatusDocType,(result)=>{       
			data = result.data
      let itemlist = data.itemlist.map((item,index)=>{
				item = Object.assign({quantity:'',discount_amount:'',discount_percent:'',taxinvoice_date:'',taxinvoice_no:'',has_vat:item.vat>'0'?true:false}, item)
				return item
			})
			data.itemlist = itemlist
			data.doc = Object.assign({customer_name:'',customer_address:'',customer_tax:'',work_no:'',car:'',withholdamount:'0',withholdpercentage:'0',vat:'0'}, data.doc)
			docNo = result.data.doc.receiptvoucher_no
			// defaultVat = (data.doc.vat_type==='VAT_EXCLUDE'?'out':data.doc.vat_type==='VAT_INCLUDE'||typeof data.doc.vat_type==='undefined'?'in':'no')
			defaultVat = 'out'
			defaultVatDeduct = data.doc.withholdpercentage===undefined?'0':data.doc.withholdpercentage
			vatDeduct = data.doc.withholdamount
			// hideTr = 'none'
			hideTr = (data.doc.withholdpercentage>0?'':'none')
    	styleBBR = 'bbr-b'
			styleBR = 'br-b'
			this.setState({data:data},()=>{
				// data.itemlist = this.sortRowIndex(data.itemlist)
				this.setState({loading:false,docNo:docNo,data:data,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})      
			})	
    })
	}

	loadPONewDoc(docNo) {
		let {data,defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR} = this.state
    this.setState({loading:true})
    GenDocStore.newDocPO(this.props.docType,this.props.docSName,docNo,this.props.poDocType,(result)=>{       
			data = Object.assign({itemlist:[]}, result.data)
			data.doc = Object.assign({customer_name:'',customer_address:'',customer_tax:'',work_no:'',car:'',withholdamount:'0',withholdpercentage:'0',vat:'0'}, data.doc)
			docNo = (this.props.docType==='paymentvoucher'?result.data.doc.paymentvoucher_no:result.data.doc.receiptvoucher_no)
			defaultVat = (data.doc.vat_type==='VAT_EXCLUDE'?'out':data.doc.vat_type==='VAT_INCLUDE'||typeof data.doc.vat_type==='undefined'?'in':'no')	
			defaultVatDeduct = data.doc.withholdpercentage===undefined?'0':data.doc.withholdpercentage
			vatDeduct = data.doc.withholdamount
			// hideTr = 'none'
			hideTr = (data.doc.withholdpercentage>0?'':'none')
    	styleBBR = 'bbr-b'
			styleBR = 'br-b'
			data.itemlist = data.itemlist.map((item,index)=>{
				item = Object.assign({has_vat:(item.vat>0?true:false)},item)
				return item
			})
			this.setState({data:data},()=>{
				data.itemlist = this.sortRowIndex(data.itemlist)
				this.setState({loading:false,docNo:docNo,data:data,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})      
			})	
		})
	}

	loadNewDocFromWork(docType,docSName,workNo) {
		let {data,docNo,defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR} = this.state
		this.setState({loading:true})
		GenDocStore.newDocFromWork(docType,docSName,workNo,(result)=>{
			data = result.data
      let itemlist = data.itemlist.map((item,index)=>{
				item = Object.assign({discount_amount:'',discount_percent:'',taxinvoice_date:'',taxinvoice_no:''}, item)
				return item
			})
			data.itemlist = itemlist
			data.doc = Object.assign({customer_tax:'',work_no:'',car:'',withholdamount:'0',withholdpercentage:'0',vat:'0'}, data.doc)
			if (this.props.docType==='deliveryslip')
				docNo = result.data.doc.deliveryslip_no
			else if (this.props.docType==='tempdeliverynote')
				docNo = result.data.doc.Tempdeliverynote_no

			defaultVat = (data.doc.vat_type==='VAT_EXCLUDE'?'out':data.doc.vat_type==='VAT_INCLUDE'||typeof data.doc.vat_type==='undefined'?'in':'no')	
			defaultVatDeduct = data.doc.withholdpercentage===undefined?'0':data.doc.withholdpercentage
			vatDeduct = data.doc.withholdamount
			// hideTr = 'none'
			hideTr = (data.doc.withholdpercentage>0?'':'none')
    	styleBBR = 'bbr-b'
			styleBR = 'br-b'
			this.setState({data:data},()=>{
				data.itemlist = this.sortRowIndex(data.itemlist)
				this.setState({loading:false,data:data,docNo:docNo,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})
			})	
		})
	}
	
	loadData(docNo) {
		let {data,defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR,pdf_template} = this.state
		this.setState({loading:true,docNo:docNo})
    GenDocStore.loadDoc(docNo,this.props.docType,this.props.docSName,(result)=>{
      data = result.data
      let itemlist = data.itemlist.map((item,index)=>{
				item = Object.assign({discount_amount:'',discount_percent:'',taxinvoice_date:'',taxinvoice_no:'',has_vat:item.vat>'0'?true:false}, item)
				return item
			})
			data.itemlist = itemlist
			data.doc = Object.assign({customer_tax:'',work_no:'',car:'',reason:'',taxinvoice_amount:data.doc.amount,vat:'0'}, data.doc)
			defaultVat = (data.doc.vat_type==='VAT_EXCLUDE'?'out':data.doc.vat_type==='VAT_INCLUDE'||typeof data.doc.vat_type==='undefined'?'in':'no')
			defaultVatDeduct = data.doc.withholdpercentage===undefined?'0':data.doc.withholdpercentage
			vatDeduct = data.doc.withholdamount
			if (defaultVatDeduct!=='0') {
				hideTr = ''
  			styleBBR = ''
  			styleBR = 'bbr-b'
			}
			if (this.props.docType==='billingnote')
				pdf_template = result.pdf_template
			
			this.setState({data:data},()=>{
				data.itemlist = this.sortRowIndex(data.itemlist)			
				this.setState({pdf_template:pdf_template,loading:false,data:data,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})
			})	
		})
	}	

	setDataFromTaxinvoice(datas,taxinvoice_no='',bill_no="") {
		let {defaultVat,defaultVatDeduct,vatDeduct,hideTr,styleBBR,styleBR} = this.state
		let {docType} = this.props
		this.setState({loading:true})
		GenDocStore.newDoc(this.props.docType,this.props.docSName,(result)=>{
			let itemlist = datas.itemlist.map((item,index)=>{
				item = Object.assign({discount_amount:'',discount_percent:'',taxinvoice_date:'',taxinvoice_no:''}, item)
				return item
			})
			datas.doc = Object.assign(datas.doc,result.data.doc, {car:'',reason:'',bill_taxinvoice_no:bill_no,taxinvoice_no:taxinvoice_no,taxinvoice_amount:datas.doc.amount,withholdamount:'0',withholdpercentage:'0',vat:'0',work_no:datas.doc.worklist})
			datas.itemlist = itemlist
			defaultVat = (datas.doc.vat_type==='VAT_EXCLUDE'?'out':datas.doc.vat_type==='VAT_INCLUDE'?'in':'no')
			defaultVatDeduct = datas.doc.withholdpercentage===undefined?'0':datas.doc.withholdpercentage
			vatDeduct = datas.doc.withholdamount
			if (defaultVatDeduct!=='0') {
				hideTr = ''
				styleBBR = ''
				styleBR = 'bbr-b'
			}
			
			let docNo = (result.data.doc[docType+'_no']!==undefined)?result.data.doc[docType+'_no']:'';
			this.setState({docNo:docNo,loading:false,data:datas,defaultVat:defaultVat,defaultVatDeduct:defaultVatDeduct,vatDeduct:vatDeduct,hideTr:hideTr,styleBBR:styleBBR,styleBR:styleBR})
		})	
	}
	
	getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getNumberCommas(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
	
  // getTotalBeforeVat() {
	// 	let {data,defaultVat} = this.state
	// 	let {docType} = this.props
	// 	let sum = 0
	// 	if (docType==='receiptvoucher'||docType==='paymentvoucher') {
	// 		data.itemlist.forEach((item,index)=>{
	// 			sum += parseFloat(this.getAmountPerRow(index))
	// 		})
	// 		if (defaultVat==='out'){
	// 			sum = sum-this.getTotalVat()
	// 		}
	// 	} else {
	// 		data.itemlist.forEach((item,index)=>{
	// 			sum += parseFloat(this.getAmountPerRow(index))
	// 		})
	// 		if (defaultVat==='in'){
	// 			sum = sum/1.07
	// 		}
	// 	}		
  // 	return sum
	// }
	
	getTotalBeforeVat() {
		let {data,defaultVat} = this.state
		let {docType} = this.props
		let sum = 0
		data.itemlist.forEach((item,index)=>{
			let amount = (docType==='receiptvoucher'?item.total*1:(item.price_per_unit*item.quantity)*1)
			if (defaultVat==='in')
				sum += (amount-this.getVatPerRow(index))
			else
				sum += amount
		})
		return sum
	}	

  // getTotalVat() {
	// 	let {data,defaultVat} = this.state
	// 	let {docType} = this.props
	// 	let sum = 0
  // 	if (defaultVat==='no')
  // 		sum = 0.00
	// 	else {
	// 		if (docType==='receiptvoucher'||docType==='paymentvoucher') {
	// 			let sum_vat = 0
	// 			data.itemlist.forEach((item,index)=>{
	// 				if (item.has_vat) {
	// 					sum_vat += (this.getValid(data.itemlist[index].amount)*1)
	// 				}	
	// 			})
	// 			if (defaultVat==='in'){
	// 				sum_vat = sum_vat/1.07
	// 			}
	// 			sum = (sum_vat * 0.07) 
	// 		} else
	// 			sum = (this.getTotalBeforeVat() * 0.07) 
	// 	}		
  // 	return sum
	// }
	
	getTotalVat() {
		let {data} = this.state
		let sum = 0
		data.itemlist.forEach((item,index)=>{
			sum += this.getVatPerRow(index)
		})
		return sum
	}

  // getTotalNet() {
  // 	return parseFloat(this.getTotalBeforeVat()) + parseFloat(this.getTotalVat())
	// }

	getTotalNet() {
		let {data} = this.state
		let sum = 0
		data.itemlist.forEach((item,index)=>{
			sum += this.getTotalPerRow(index)
		})
		return sum
	}
	
	getVatDeduct() {
		let {defaultVatDeduct,vatDeduct} = this.state
		if (defaultVatDeduct!==0) { 
  		vatDeduct = (this.getTotalBeforeVat() / 100) * defaultVatDeduct
  		return vatDeduct
  	} else {
			return '0'
		}
  }

  getTotalPayment() {
  	let {defaultVatDeduct,totalPayment} = this.state
  	if (defaultVatDeduct !== 0) {
  		totalPayment = this.getTotalNet() - this.getVatDeduct()
  		return totalPayment
		}	
		return '0'
	}

	getTotalPerRow(index) { 
		let {data,defaultVat} = this.state
		let {docType} = this.props
		let total = 0
		let vat = 0
		let qty = (data.itemlist[index].quantity===''||data.itemlist[index].quantity===null||data.itemlist[index].quantity===undefined||isNaN(data.itemlist[index].quantity)?0:data.itemlist[index].quantity*1)
		let price_per_unit = (data.itemlist[index].price_per_unit===''||data.itemlist[index].price_per_unit===null||data.itemlist[index].price_per_unit===undefined||isNaN(data.itemlist[index].price_per_unit)?0:data.itemlist[index].price_per_unit*1)
		let amount = (docType==='paymentvoucher'?price_per_unit*qty:data.itemlist[index].amount) // (docType==='paymentvoucher'?price_per_unit*qty:data.itemlist[index].total)
		if (data.itemlist[index].has_vat) {
			if (defaultVat==='in'||defaultVat==='no') {
				total = amount
			} else {
				vat = amount*0.07
				total = (amount*1)+(vat*1)
			}
		} else {
			total = amount	
		}
		return total
	}
	
	getAmountPerRow(index) { 
		let {data,defaultVat} = this.state
		let {docType} = this.props
		// let total = 0
		let vat = 0
		let qty = (data.itemlist[index].quantity===''||data.itemlist[index].quantity===null||data.itemlist[index].quantity===undefined||isNaN(data.itemlist[index].quantity)?0:data.itemlist[index].quantity*1)
		let price_per_unit = (data.itemlist[index].price_per_unit===''||data.itemlist[index].price_per_unit===null||data.itemlist[index].price_per_unit===undefined||isNaN(data.itemlist[index].price_per_unit)?0:data.itemlist[index].price_per_unit*1)
		let amount = (docType==='paymentvoucher'?price_per_unit*qty:data.itemlist[index].amount)
		// if (data.itemlist[index].has_vat) {
		// 	if (defaultVat==='in'||defaultVat==='no') {
		// 		total = amount
		// 	} else {
		// 		vat = amount*0.07
		// 		total = (amount*1)+(vat*1)
		// 	}
		// } else {
		// 	total = amount	
		// }
		return amount
	}

	getVatPerRow(index) {
		let {data,defaultVat} = this.state
		let {docType} = this.props
		let vat = 0
		let qty = (data.itemlist[index].quantity===''||data.itemlist[index].quantity===null||data.itemlist[index].quantity===undefined||isNaN(data.itemlist[index].quantity)?0:data.itemlist[index].quantity*1)
		let price_per_unit = (data.itemlist[index].price_per_unit===''||data.itemlist[index].price_per_unit===null||data.itemlist[index].price_per_unit===undefined||isNaN(data.itemlist[index].price_per_unit)?0:data.itemlist[index].price_per_unit*1)
		let amount = (docType==='paymentvoucher'?price_per_unit*qty:data.itemlist[index].amount) // (docType==='paymentvoucher'?price_per_unit*qty:data.itemlist[index].total)
		if (data.itemlist[index].has_vat) {
			if (defaultVat==='in') {
				vat = (amount/1.07)*0.07
			} else if (defaultVat==='out')
				vat = amount*0.07
		}
		return vat
	}

	// getAmountPerRow(index) {
	// 	let {data} = this.state
	// 	let {docType} = this.props
	// 	let amount = 0
	// 	if (docType==='receiptvoucher'||docType==='paymentvoucher') {
	// 		if (docType==='paymentvoucher')
	// 			amount = this.getTotalPerRow(index)
	// 		else
	// 			amount = this.getValid(data.itemlist[index].total)
	// 	} else {
	// 		let quantity = this.getValid(data.itemlist[index].quantity)
	// 		let price_per_unit = this.getValid(data.itemlist[index].price_per_unit)
	// 		let discount_amount = this.getValid(data.itemlist[index].discount_amount)
	// 		amount += (quantity*price_per_unit)-discount_amount
	// 	}	
	// 	return amount
	// }

	sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
			item.seq = (index+1).toString()
			item.amount = this.getAmountPerRow(index)
			item.total = this.getTotalPerRow(index)
      return item
    })
    return itemlist
  }

	newEmptyRow(number){
		let {data} = this.state
		let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
    return new Array(number).fill(null).map((item,index)=>{
      return {seq:NUMBER,itemnum:'',detail:'',quantity:'',price_per_unit:'',amount:'',total:'',discount_amount:'',discount_percent:'',taxinvoice_date:'',taxinvoice_no:'',invoice_no:'',invoice_date:'',has_vat:false,vat:'',purchase_order_no:'',bf_purchase_order_item_id:''}
    })
  }

  onRowDelete(index,e) {
  	let {data} = this.state
		data.itemlist.splice(index,1)
		data.itemlist = this.sortRowIndex(data.itemlist)
  	this.setState({data:data})
	}

  onRowAdd(number) {
		let {data} = this.state
		if (data.itemlist.length===0)
			data.itemlist = this.newEmptyRow(number)
		else
			data.itemlist = data.itemlist.concat(this.newEmptyRow(number))

    this.setState({data:data})
  }

	onVatDeductChange(e) {
  	let {defaultVatDeduct} = this.state
  	let style = 'none'
  	let styleBBR = 'bbr-b'
  	let styleBR = 'br-b'
  	if (e.value !== 0) {
  		style = ''
  		styleBBR = ''
  		styleBR = 'bbr-b'
  	}

  	defaultVatDeduct = e.value
  	this.setState({defaultVatDeduct:defaultVatDeduct, hideTr:style, styleBBR:styleBBR, styleBR:styleBR})
  }

  onVatChange(e) {
  	let {total,data,defaultVat} = this.state 	
		total = parseFloat(this.getTotalVat()) + parseFloat(this.getTotalBeforeVat())
		defaultVat = e.value
		data.doc.vat_type = (defaultVat==='out'?'VAT_EXCLUDE':defaultVat==='in'?'VAT_INCLUDE':'NON_VAT')
  	this.setState({defaultVat:defaultVat,total:total})
  }

  onTextChange(key, e) {
  	let {data} = this.state
  	data.doc[key] = e.target.value
  	this.setState({data:data})
	}
	
	onTextSelect(key, e) {
  	let {data} = this.state
  	data.doc[key] = e
  	this.setState({data:data})
	}

  onCustomerClick(e) {
		let {customerType} = this.state
		if (customerType==='customer')
			this.setState({show:true})
		else if (customerType==='insurer')	
			this.setState({showInsurer:true})	
  }

  onCustomerSelect(e) {
    let {data} = this.state
		data.doc.customer_name = e.name
		data.doc.customer_address = e.address
		data.doc.customer_tax = e.tax_no
		data.doc.customer_branch = e.branch
    this.setState({data:data})
	}

	onSupSelect(e) {
		let {data} = this.state
		data.doc.customer_name = e.name
		data.doc.customer_address = e.address
		data.doc.customer_tax = e.tax_no
		data.doc.customer_branch = e.branch
    this.setState({data:data})
	}

	onInsurerSelect(e) {
    let {data} = this.state
		data.doc.customer_name = e.name
		data.doc.customer_address = e.address
		data.doc.customer_tax = e.tax_no
		data.doc.customer_branch = e.branch
    this.setState({data:data})
	}
	
	onDateChange(e) {
		let {data} = this.state
		data.doc.added_date = e
		this.setState({data:data})
	}

	getValid(value) {
		value = (value===''?0:value===null?0:value===undefined?0:isNaN(value)?0:value)
		return value
	}

	getDiscount(key,index,value) {
		let {data} = this.state
		if (key==='discount_percent') {
			let quantity = this.getValid(data.itemlist[index].quantity)
			let price_per_unit = this.getValid(data.itemlist[index].price_per_unit)
			value = this.getValid(value)
			let sum = quantity*price_per_unit
			return (sum*value)/100
		} else if (key==='discount_amount') {
			let quantity = this.getValid(data.itemlist[index].quantity)
			let price_per_unit = this.getValid(data.itemlist[index].price_per_unit)
			value = this.getValid(value)
			let sum = quantity*price_per_unit
			let percent = (value/sum)*100
			if (percent%1 !== 0)
				percent = percent.toFixed(2)
			
			return percent
		}
	}

	onInputChange(key,index,e) {
		let {data} = this.state
		let {docType} = this.props
		if (key==='price_per_unit'||key==='taxinvoice_date'||key==='total'||key==='amount')
			data.itemlist[index][key] = e
		else		
			data.itemlist[index][key] = e.target.value
		
		if (key==='price_per_unit'||key==='quantity') {
			if (docType!=='paymentvoucher')
				data.itemlist[index].amount = data.itemlist[index].price_per_unit*data.itemlist[index].quantity
			else {
				data.itemlist[index].vat = this.getVatPerRow(index)
				data.itemlist[index].amount = this.getAmountPerRow(index)
				data.itemlist[index].total = this.getTotalPerRow(index)
			}	
		} else if (key==='discount_percent')
			data.itemlist[index].discount_amount = this.getDiscount(key,index,e.target.value)
		else if (key==='discount_amount')
			data.itemlist[index].discount_percent = this.getDiscount(key,index,e.target.value)
		else if (key==='total') {
			data.itemlist[index].vat = this.getVatPerRow(index)
			data.itemlist[index].amount = this.getAmountPerRow(index)
			data.itemlist[index].total = this.getTotalPerRow(index)
		} else
			data.itemlist[index].discount_amount = this.getDiscount('discount_percent',index,data.itemlist[index].discount_percent)	
		
		this.setState({data:data})
	}

	onSaveClick() {
		this.saveGenDoc()
	}

	saveGenDoc(completeFunc) {
		let {docNo,data,defaultVat,defaultVatDeduct} = this.state
		let {docSName,messages} = this.props
		data.doc = Object.assign(data.doc, {withholdpercentage:defaultVatDeduct.toString(),withholdamount:this.getVatDeduct().toString()})
		if (defaultVat==='no'&&defaultVatDeduct==='0')
			data.doc.amount = this.getTotalBeforeVat()
		else if (defaultVat!=='no'&&defaultVatDeduct==='0')	
			data.doc.amount = this.getTotalNet()
		else if (defaultVatDeduct!=='0')
			data.doc.amount = this.getTotalPayment()	
		this.setState({loading:true,data:data})

		data.itemlist = this.sortRowIndex(data.itemlist)
		data.doc.vat = this.getTotalVat()
		let postData = {doc:data.doc,itemlist:data.itemlist}
		postData[docSName] = docNo
		// postData.itemlist[0].amount = '7798.4'
		// postData.itemlist[0].total = '8344.29'
		// postData.doc.amount = '8344.29'
		// postData.doc.vat = '545.89'
		GenDocStore.saveDoc(postData,this.props.docType,(result)=>{
      data.doc.seq_no = result.seq_no
      this.setState({loading:false,data:data})
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Save2']+this.props.title,
        level: 'info',
        position:'tc'
			});
			if(completeFunc!==undefined){
        completeFunc(result.status)
      }
    },(error)=>{
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Save fail'],
        level: 'error',
        position:'tc'
      });
      this.setState({loading:false})
    })
	}

	onPrintClick(){
		let {docNo,pdf_template} = this.state
		let {docType} = this.props
		this.saveGenDoc((result)=>{
			if (result==='OK') {
				let printPage = (docType==='receiptvoucher'||docType==='paymentvoucher'?'PrintVoucherDoc':'PrintGeneralSlipDoc')
				let HOST = './pdf/v2?startPage='
				if (process.env.NODE_ENV === "development")
					HOST = '?startPage='
				
				let url = HOST+printPage+'&doc_no='+docNo+'&doc_name='+this.props.docName
				if (docType==='billingnote')
					url = HOST+pdf_template.PrintBillingNoteInsurer+'&bn='+docNo
				else if (docType==='receiptvoucher'||docType==='paymentvoucher') {
					url += '&showTaxInvoiceRefItem=true'
				}
				this.refs.iframe.loadUrl(url)
			}	
		})
	}

	onDelClick() {
    let {docNo} = this.state
    this.setState({loading:true})
    GenDocStore.delGenDoc(this.props.docType,docNo,()=>{
      this.setState({showDelConfirm:false,loading:false})
      if (this.props.onClose!==undefined)
        this.props.onClose()
    })      
  }
	
	onCloseClick(){
		if(this.props.onClose!==undefined){
      this.props.onClose()
    }
	}

	onInvoiceSelect(rItem) {
		let {data} = this.state
		let {docType} = this.props
		rItem.itemlist.forEach((item,index)=>{
			let findDup = data.itemlist.findIndex(x=>x.invoice_no===item.doc_no)
			let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
			if (findDup===-1) {
				if (docType==='billingnote') {
					data.itemlist.push({
						amount:item.amount,bf_billingnote_item_id:'',billingnote_no:item.doc_no,detail:item.doc_no,discount_amount:'',discount_percent:'',invoice_no:item.doc_no,price_per_unit:item.amount,quantity:'1',seq:NUMBER,vat_type:'VAT_EXCLUDE'	
					})
				} else if (docType==='receiptvoucher') {
					data.itemlist.push({
						amount:item.amount,total:item.amount,detail:item.doc_no,discount_amount:'',discount_percent:'',taxinvoice_no:'',taxinvoice_date:'',quantity:'1',seq:NUMBER,has_vat:false,vat:''
					})
				}	
			}		
			this.setState({data:data,showInvoiceList:false})
		})
	}

	// onPOSelect(rItem) { 
	// 	let {data} = this.state
	// 	rItem.itemlist.forEach((item,index)=>{
	// 		let findDup = data.itemlist.findIndex(x=>x.purchase_order_no===item.purchase_order_no)
	// 		let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
	// 		if (findDup===-1) {
	// 			data.itemlist.push({
	// 				amount:item.amount,total:item.amount,detail:item.shop_name,discount_amount:'',discount_percent:'',taxinvoice_no:'',taxinvoice_date:'',purchase_order_no:item.purchase_order_no,quantity:'1',seq:NUMBER,has_vat:item.vat_type!=='NON_VAT'?true:false,vat:''
	// 			})
	// 		}		
	// 		this.setState({data:data,showPOList:false})
	// 	})
	// }

	onPOSelect(rItem) {
		let {data} = this.state
		rItem.itemlist.forEach((sitem,sindex)=>{
			sitem.items.forEach((item,index)=>{
				// let findDup = data.itemlist.findIndex(x=>x.purchase_order_no===item.purchase_order_no&&x.itemnum===item.itemnum)
				let findDup = data.itemlist.findIndex(x=>x.purchase_order_no===item.purchase_order_no&&x.bf_purchase_order_item_id===item.bf_purchase_order_item_id)
				let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
				if (findDup===-1) {
					data.itemlist.push({
						bf_purchase_order_item_id:item.bf_purchase_order_item_id,itemnum:item.itemnum,price_per_unit:item.price_per_unit,amount:(item.price_per_unit*item.quantity),total:(item.price_per_unit*item.quantity),detail:item.detail,discount_amount:'',discount_percent:'',taxinvoice_no:'',taxinvoice_date:'',purchase_order_no:item.purchase_order_no,quantity:item.quantity,seq:NUMBER,has_vat:item.vat>0?true:false,vat:item.vat
					})
				}	
			})	
		})
		this.setState({data:data,showPOList:false})
	}

	onTaxinvoiceSelect(rItem) {
		let {data} = this.state
		rItem.itemlist.forEach((item,index)=>{
			let findDup = data.itemlist.findIndex(x=>x.bf_taxinvoice_item_id===item.bf_taxinvoice_item_id)
			let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
			if (findDup===-1) {
				data.itemlist.push({
					bf_taxinvoice_item_id:item.bf_taxinvoice_item_id,creditnote_no:item.taxinvoice_no,bf_debitnote_item_id:'',debitnote_no:item.taxinvoice_no,amount:item.amount,price_per_unit:item.amount,detail:item.detail,discount_amount:'',discount_percent:'',quantity:'1',seq:NUMBER
				})
			}		
			this.setState({data:data,showTaxList:false})
		})
	}

	onPullClick() {
		let {pullType,data} = this.state
		WorkdocStore.loadAccountInfo(data.doc.work_no,pullType,(result)=>{
			if (result.status==='OK') {
				data.doc.customer_name = result.info.name
				data.doc.customer_address = result.info.address
				data.doc.customer_tax = result.info.tax_no
				data.doc.customer_branch = result.info.branch
				this.setState({data:data})
			}	
			this.setState({showPull:false,pullType:''})
		},()=>{
			this.setState({showPull:false,pullType:''})
		})
	}

	onCustomerTypeChange(value) {
		this.setState({customerType:value})
	}

	onCustomerTypeClick() {
		let {customerType} = this.state
		if (customerType!=='') {
			this.setState({showSelectCustomerType:false})
			this.onCustomerClick()
		}	
	}
	
	onHasVatChange(index) {
		let {data} = this.state
		if (data.itemlist[index].has_vat)
			data.itemlist[index].has_vat = false
		else
			data.itemlist[index].has_vat = true
		
		data.itemlist[index].vat = this.getVatPerRow(index)	
		data.itemlist[index].amount = this.getAmountPerRow(index)
		data.itemlist[index].total = this.getTotalPerRow(index)
		this.setState({data:data})	
	}

	onRowSelect(item) {
		this.setState({showTable:false})
    this.refs.poDoc.loadData(item.purchase_order_no)
	}

	onPODocClose() {
		this.setState({showTable:true})
	}

	onShowModalClick() {
		let {docType} = this.props
		if (docType==='paymentvoucher')
			this.setState({showSup:true})
		else
			this.setState({showSelectCustomerType:true})		
	}

  renderTaxNo() {
    let {messages} = this.props
  	if (this.props.docType==='bill') {
  		return(
  			this.renderDateInput()
  		)
  	} else {
  		return(
  			<Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Taxpayer Number']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='asterisk'/></InputGroup.Addon>
	              <FormControl value={this.state.data.doc.customer_tax} onChange={this.onTextChange.bind(this,'customer_tax')} />
	            </InputGroup>            
	          </FormGroup>
	        </Col>
	    )    
		}        
  }

  renderDate() {
  	if (this.props.docType==='bill') {
  		return('')
  	} else {
  		return(
  			this.renderDateInput()
  		)
  	}	
  }

  renderDateInput() {
		let {messages} = this.props
  		return(
  			<Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Date']} :</ControlLabel>
	            <DatePicker 
									maxWidth='100%'
	                showIcon={true}
	                showFooter={true}
	                popPlacement='bottom'
	                buddhistEra
									value={this.state.data.doc.added_date}
									onChange={this.onDateChange.bind(this)}
	            />           
	          </FormGroup>
	        </Col>
  		)
  }

  renderHeaderRow(){
		let {messages,docType} = this.props
		let {data,reasonList} = this.state
		return (
	   	<div>
	   	  <Row>
	        <Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Customer']} : <span style={{cursor:'pointer',display:(docType!=='receiptvoucher'&&docType!=='paymentvoucher'?'':'none')}} onClick={()=>this.setState({showPull:true,pullType:'owner'})} className="label label-default">{messages['Pull data car owner']}</span> <span style={{cursor:'pointer',display:(docType!=='receiptvoucher'&&docType!=='paymentvoucher'?'':'none')}} onClick={()=>this.setState({showPull:true,pullType:'insurer'})} className="label label-default">{messages['Pull data insurance']}</span></ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='user'/></InputGroup.Addon>
	              <FormControl value={data.doc.customer_name} onChange={this.onTextChange.bind(this,'customer_name')} />
	              <InputGroup.Addon style={{cursor:'pointer'}} onClick={this.onShowModalClick.bind(this)}><FontAwsome name='plus'/></InputGroup.Addon>
	            </InputGroup>   
	            <SWTNewCustomerPopup 
	                show={this.state.show} 
	                onHide={()=>{this.setState({show:false})}}
	                onSelect={this.onCustomerSelect.bind(this)}
	            />    
							<InsurerPageModal
								show={this.state.showInsurer} 
								onHide={()=>{this.setState({showInsurer:false})}}
								onSelect={this.onInsurerSelect.bind(this)}
							/>
	          </FormGroup>
	        </Col>
	        <Col md={6}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Address']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='location-arrow'/></InputGroup.Addon>
	              <FormControl value={data.doc.customer_address} onChange={this.onTextChange.bind(this,'customer_address')} />
	            </InputGroup>            
	          </FormGroup>
	        </Col>
	        {this.renderTaxNo()}
	      </Row>
				<Row>
	        <Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Branch']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='asterisk'/></InputGroup.Addon>
	              <FormControl value={data.doc.customer_branch} onChange={this.onTextChange.bind(this,'customer_branch')} />
	            </InputGroup>
						</FormGroup>
					</Col>
				</Row>			
	      <Row>
					{docType!=='billingnote'&&docType!=='receiptvoucher'&&docType!=='paymentvoucher'?
	        <Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Worksheet Number']} : {messages['Status']} <span className="label label-default">{messages['Start']}</span></ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='file'/></InputGroup.Addon>
	              <FormControl value={data.doc.work_no!==null?data.doc.work_no:''} readOnly={true} />
	            </InputGroup>    
	          </FormGroup>
	        </Col>
					:''}
					{docType!=='billingnote'&&docType!=='receiptvoucher'&&docType!=='paymentvoucher'?
	        <Col md={6}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Car Information']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='car'/></InputGroup.Addon>
	              <FormControl value={data.doc.car!==null?data.doc.car:''} onChange={this.onTextChange.bind(this,'car')} />
	            </InputGroup>       
	          </FormGroup>
	        </Col>
					:''}
	        {this.renderDate()}
	      </Row>
				{docType!=='billingnote'&&docType!=='receiptvoucher'&&docType!=='paymentvoucher'?
				<Row>
	        <Col md={3}>
						<FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Reason']} :</ControlLabel>
	            <CKAutocomplete
											top='-35px'
                      items={reasonList}
                      value={data.doc.reason===null||data.doc.reason===undefined?'':data.doc.reason}
                      onChange={this.onTextChange.bind(this,'reason')}
                      onSelect={this.onTextSelect.bind(this,'reason')}
              />     
	          </FormGroup>
					</Col>
					<Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Tax invoice']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='file'/></InputGroup.Addon>
	              <FormControl disabled={true} value={data.doc.bill_taxinvoice_no} onChange={()=>{}} />
	            </InputGroup>       
	          </FormGroup>
	        </Col>
					<Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Original value']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='money'/></InputGroup.Addon>
	              <FormControl disabled={true} value={this.getNumberFormat(data.doc.taxinvoice_amount)} onChange={()=>{}} />
	            </InputGroup>       
	          </FormGroup>
	        </Col>
				</Row> 
				:''}
	    </div>  
    )
  }

  renderNewItemButton(){
    let {messages,docType} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
					<ButtonToolbar>
						<Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;{messages['Add Item']}</Button>
						<Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwsome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
						{docType==='billingnote'||docType==='debitnote'||docType==='creditnote'||docType==='paymentvoucher'?
						<Button bsStyle='primary' onClick={docType==='billingnote'||docType==='receiptvoucher'?()=>{this.setState({showInvoiceList:true})}:docType==='paymentvoucher'?()=>{this.setState({showPOList:true})}:()=>{this.setState({showTaxList:true})}}><FontAwsome name='plus'/>&nbsp;{messages['Pull list']+(docType==='billingnote'||docType==='receiptvoucher'?messages['Tax invoice']:docType==='paymentvoucher'?messages['Order number']:messages['Tax invoice'])}</Button>
						:''}
						</ButtonToolbar>     
				</Col>
      </Row>
    )
  }

  renderRemark(){
    let {messages} = this.props
    return (
	      <Col md={3}>
	        <FormGroup
	          controlId={null}
	          validationState={null}
	        >
	          <ControlLabel>{messages['Note']} </ControlLabel>
	          <FormControl 
								onChange={this.onTextChange.bind(this,'remark')}
								value={this.state.data.doc.remark} 
								componentClass="textarea"
								rows={5}
								style={{width:'100%'}}
	          />            
	        </FormGroup>
	      </Col>
    )
  }

  renderSummary() {
		let {messages,docType} = this.props
		let {data} = this.state
		let options = []
		if (this.props.docType==='receiptvoucher'||this.props.docType==='paymentvoucher') {
  			options = [
  				{ "value": 0, "label": "0" },
  				{ "value": 0.75, "label": "0.75%" },
					{ "value": 1, "label": "1%" },
					{ "value": 1.5, "label": "1.5%" },
  				{ "value": 2, "label": "2%" },
  				{ "value": 3, "label": "3%" },
  				{ "value": 5, "label": "5%" },
  				{ "value": 10, "label": "10%" },
  				{ "value": 15, "label": "15%" }
				]
		} else {
			options = [
				{ "value": 0, "label": "0" },
				{ "value": 0.75, "label": "0.75%" },
				{ "value": 1, "label": "1%" },
				{ "value": 2, "label": "2%" },
				{ "value": 3, "label": "3%" },
				{ "value": 5, "label": "5%" },
				{ "value": 10, "label": "10%" },
				{ "value": 15, "label": "15%" }
			]
		} 		
		const isCreditDebitNote = (docType==='creditnote' || docType==='debitnote')
  	return([
  			<Col md={5} key={0}></Col>,
		    <Col md={4} key={1} className="">
		    	<div>
		    		<table className='table table-doc-summary'>
				        <tbody>
									{isCreditDebitNote && (
									<tr>
				          	<td style={{width:'60%'}} className="text-right">มูลค่าตามเอกสารเดิม</td>
				          	<td style={{width:'35%'}} className="text-right">{this.getNumberFormat(data.doc.taxinvoice_amount)}</td>
				          	<td style={{width:'5%'}} className="text-right">{messages['Bath']}</td>
				          </tr>
									)}
									{isCreditDebitNote && (
									<tr>
				          	<td style={{width:'60%'}} className="text-right">มูลค่าที่ถูกต้อง</td>
				          	<td style={{width:'35%'}} className="text-right">{this.getNumberFormat((data.doc.taxinvoice_amount*1)+(this.getTotalBeforeVat()*1))}</td>
				          	<td style={{width:'5%'}} className="text-right">{messages['Bath']}</td>
				          </tr>
									)}
									{isCreditDebitNote && (
									<tr>
				          	<td style={{width:'60%'}} className="text-right">ผลต่าง</td>
				          	<td style={{width:'35%'}} className="text-right">{this.getNumberFormat(this.getTotalBeforeVat())}</td>
				          	<td style={{width:'5%'}} className="text-right">{messages['Bath']}</td>
				          </tr>
									)}
				          <tr>
				          	<td style={{width:'60%'}} className="text-right">{messages['Total Before Tax']}</td>
				          	<td style={{width:'35%'}} className="text-right">{this.getNumberFormat(this.getTotalBeforeVat())}</td>
				          	<td style={{width:'5%'}} className="text-right">{messages['Bath']}</td>
				          </tr>
				          <tr>
				          	<td className="br-b text-right">{messages['Vat']} 7%</td>
				          	<td className="br-b text-right">{this.getNumberFormat(this.getTotalVat())}</td>
				          	<td className="br-b text-right">{messages['Bath']}</td>
				          </tr>
				          <tr>
				          	<td className="text-right"><b>{messages['Net Amount']}</b></td>
				          	<td className="text-right">{this.getNumberFormat(this.getTotalNet())}</td>
				          	<td className="text-right">{messages['Bath']}</td>
				          </tr>
				          <tr>
				          	<td colSpan={2} className={this.state.styleBBR} style={{textAlign:'right', lineHeight:'2',verticalAlign:'middle'}}>{messages['Withholding']}</td>
				          	<td className={this.state.styleBBR}>
				          		<Select
					                clearable={false}
					                name="form-field-name"
					                value={this.state.defaultVatDeduct}
					                options={options}
													onChange={this.onVatDeductChange.bind(this)}
													style={{width:'80px'}}
					            />
				          	</td>
				          </tr>
				          <tr style={{display:this.state.hideTr}}>
				          	<td style={{textAlign:'right'}}><b>{messages['Withholding']} {this.state.defaultVatDeduct}%</b></td>
				          	<td style={{textAlign:'right'}}>{this.getNumberFormat(this.getVatDeduct())}</td>
				          	<td style={{textAlign:'right'}}>{messages['Bath']}</td>
				          </tr>
				          <tr style={{display:this.state.hideTr}}>
				          	<td className={this.state.styleBR} style={{textAlign:'right'}}><b>{messages['Payments']}</b></td>
				          	<td className={this.state.styleBR} style={{textAlign:'right'}}>{this.getNumberFormat(this.getTotalPayment())}</td>
				          	<td className={this.state.styleBR} style={{textAlign:'right'}}>{messages['Bath']}</td>
				          </tr>
				        </tbody>
				      </table>
		    	</div>    
		    </Col>
		])
  }

  renderColumnDiscountPercent(){
    let {messages,docType} = this.props
    if (this.props.showDiscount) {
      return (
        <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} style={{width:'100px'}} className='text-center'>{messages['Discount %']}</th> 
      )
    }else{
      return (
        ''
      )
    }
  }

  renderColumnDiscountAmount(){
    let {messages,docType} = this.props
    if (this.props.showDiscount) {
      return (
        <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} style={{width:'100px'}} className='text-center'>{messages['Discount']}</th>
      )
    }else{
      return (
        ''
      )
    }
  }

  renderTable(){
		let {messages,docType} = this.props
    return (
			<div className='table-responsive'>
	      <table className='table table-hover table-bordered-solid table-gen-doc' style={{marginBottom:'0',minWidth:'1580px'}}>
	        <thead>
	          <tr>
							<th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} className='text-center' style={{width:'80px'}}>
								{messages['Number']}
							</th>
							{docType==='receiptvoucher'||docType==='paymentvoucher'?
							<th className='text-center' colSpan={2}>{messages['Tax invoice']}</th>
							:''}
							{docType==='paymentvoucher'?
							<th style={{width:'130px'}} rowSpan={2} className='text-center'>{messages['Order number']}</th>
							:''}
	            <th style={{width:docType==='receiptvoucher'||docType==='paymentvoucher'?'500px':'700px'}} rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1}>{messages['Item']}</th>
							{docType==='paymentvoucher'?
							<th rowSpan={2} className='text-center' style={{width:'90px'}}>{messages['Quantity']}</th>
							:''}
							{docType==='paymentvoucher'?
							<th rowSpan={2} className='text-center' style={{width:'100px'}}>{messages['Price per unit']}</th>
							:''}
	            <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} className='text-center' style={{width:docType==='receiptvoucher'||docType==='paymentvoucher'?'150px':'90px'}}>{docType==='receiptvoucher'||docType==='paymentvoucher'?messages['Total price']:messages['Quantity']}</th>
							{docType==='receiptvoucher'||docType==='paymentvoucher'?
							<th rowSpan={2} className='text-center' style={{width:'90px'}}>{messages['Have vat']}</th>
							:''}
	            <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} className='text-center' style={{width:docType==='receiptvoucher'||docType==='paymentvoucher'?'90':'100px'}}>{docType==='receiptvoucher'||docType==='paymentvoucher'?'Vat 7%':messages['Price/Unit']}</th>
	            {this.renderColumnDiscountPercent()}
              {this.renderColumnDiscountAmount()}
	            <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} className='text-center' style={{width:'150px'}}>{docType==='receiptvoucher'||docType==='paymentvoucher'?messages['Total amount']:messages['Amount']}</th>
	            <th rowSpan={docType==='receiptvoucher'||docType==='paymentvoucher'?2:1} className='text-center' style={{width:'80px'}}>{messages['Delete']}</th>
	          </tr>
						{docType==='receiptvoucher'||docType==='paymentvoucher'?
						<tr>
							<th style={{width:'200px'}} className='text-center'>{messages['Number2']}</th>
							<th style={{width:'200px'}} className='text-center'>{messages['Day/Month/Year']}</th>
						</tr>
						:''}
	        </thead>
	        <tbody>
	          {this.renderRowData()}
	        </tbody>
	      </table>
			</div>	
    )
  }

  renderDiscount(value,key,index) {
		let {data} = this.state
    if (this.props.showDiscount) {
      return (
        <td key={8+key} className='text-right'>
          <FormGroup>
            <InputGroup>
              <FormControl 
                style={{borderTopRightRadius:'4px',borderBottomRightRadius:'4px'}}
                type="text" 
                className='text-center input-gen-doc'
                value={key==='discount_amount'&&data.itemlist[index].discount_percent===''?'':value}
                onChange={this.onInputChange.bind(this,key,index)}
              />
              <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit'}}>{key==='discount_percent'?'%':''}</InputGroup.Addon>
            </InputGroup>
          </FormGroup>           
        </td>
    )
    }else{
      return ('')
    }
	}

	renderColDetail(index,item) {
		let {docType,messages} = this.props
		let {can_drag,darg_id} = this.state
    let uniq = item.seq
    let hover = (
      <OverlayTrigger
          key={'right'}
          placement={'right'}
          overlay={
              <Tooltip id={'tooltip-right'}>
                Hold & darg to sort the Items
              </Tooltip>
          }
          >
          <div className='wrap-tool'>
            <div className='card-tool'><FontAwsome name='bars' /></div>
          </div>
      </OverlayTrigger>
		)
		let _PO = (<div></div>)
    if (item.purchase_order_no!==''&&item.purchase_order_no!==null) {
    	let po_hover = (
        <Popover id="popover-positioned-right" title={item.purchase_order_no}>
          <strong>{messages['Click icon to view work']}</strong>
        </Popover>
      )  
      _PO = (
        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={po_hover}>
          <div onClick={this.onRowSelect.bind(this,item)} ><FontAwsome name='file-text' className='color-blue' />&nbsp;{item.purchase_order_no}</div>
        </OverlayTrigger>
      )
    }
		return([
			<td 
                  key={0} 
                  className='text-center'
                  style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
                  onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
                  onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
                >
                  {can_drag&&darg_id===uniq?hover:index+1}
			</td>,
			docType==='receiptvoucher'||docType==='paymentvoucher'?
			<td key={1} className='text-center'>
				<FormControl 
					className="input-gen-doc" 
					type="text" 
					value={item.taxinvoice_no} 
					onChange={this.onInputChange.bind(this,'taxinvoice_no',index)}
				/>
			</td>
			:'',
			docType==='receiptvoucher'||docType==='paymentvoucher'?
			<td key={2} className='text-center'>
				<DatePicker 
					maxWidth='100%'
					showIcon={true}
					showFooter={true}
					popPlacement='bottom'
					buddhistEra
					value={item.taxinvoice_date}
					onChange={this.onInputChange.bind(this,'taxinvoice_date',index)}
				/>
			</td>
			:'',
			docType==='paymentvoucher'?
			<td key={3} className='text-center' style={{verticalAlign:'middle'}}>
				{_PO}
			</td>
			:'',
			<td key={4}>
				<FormControl 
					className="input-gen-doc" 
					type="text" 
					value={item.detail!==null?item.detail:''} 
					onChange={this.onInputChange.bind(this,'detail',index)}
				/>
			</td>,
			docType==='paymentvoucher'?
			<td key={11} className='text-center' style={{verticalAlign:'middle'}}>
				<FormControl 
					className='text-center input-gen-doc'
					type="text"
					value={item.quantity} 
					onChange={this.onInputChange.bind(this,'quantity',index)}
				/>
			</td>
			:'',
			docType==='paymentvoucher'?
			<td key={12} className='text-center' style={{verticalAlign:'middle'}}>
				<InputNumber
					className='input-gen-doc text-right'
					value={item.price_per_unit} 
					onChange={this.onInputChange.bind(this,'price_per_unit',index)}
					formatter={value =>
						`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
					}
				/>
			</td>
			:'',
			<td key={5} className={docType==='paymentvoucher'?'text-right':'text-center'} style={{verticalAlign:'middle'}}>
				{docType==='receiptvoucher'?
				<InputNumber
					className='input-gen-doc text-right'
					value={item.amount} 
					onChange={this.onInputChange.bind(this,'amount',index)}
					formatter={value =>
						`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
					}
				/>
				:
				docType==='paymentvoucher'?
				this.getNumberFormat(item.amount)
				:
				<FormControl 
					className='text-center input-gen-doc'
					type="text"
					value={item.quantity} 
					onChange={this.onInputChange.bind(this,'quantity',index)}
				/>}
			</td>,
			docType==='receiptvoucher'||docType==='paymentvoucher'?
			<td key={6} className='text-center' style={{verticalAlign:'middle'}}>
				<Checkbox
					onChange={this.onHasVatChange.bind(this,index)}
					checked={item.has_vat}
					checkboxClass="icheckbox_square-blue"
					increaseArea="20%"
					label={''}
				>
				</Checkbox>
			</td>
			:'',
			<td key={7} className='text-center' style={{verticalAlign:'middle'}}>
				{docType==='receiptvoucher'||docType==='paymentvoucher'?
				this.getNumberFormat(this.getVatPerRow(index))
				:
				<InputNumber
					className='text-right input-gen-doc'
					value={item.price_per_unit} 
					onChange={this.onInputChange.bind(this,'price_per_unit',index)}
					formatter={value =>
						`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
					}
				/>
				}
			</td>,
			this.renderDiscount(item.discount_percent,'discount_percent',index),
			this.renderDiscount(item.discount_amount,'discount_amount',index),
			<td key={9} className='text-right' style={{verticalAlign:'middle'}}>
				{/* {docType==='receiptvoucher'||docType==='paymentvoucher'?
				this.getNumberFormat(this.getTotalPerRow(index))
				:(this.getAmountPerRow(index)==='0'?'':this.getNumberFormat(this.getAmountPerRow(index)))} */}
				{this.getNumberFormat(this.getTotalPerRow(index))}
			</td>,
			<td key={10} className='text-center'>
				<Button 
					className="btn btn-danger" 
					onClick={this.onRowDelete.bind(this, index)
				}>
					<FontAwsome name='trash' />
				</Button>
			</td>
		])
	}			

  renderRowData() {
    let {messages,showDiscount,docType,showDragDrop} = this.props
  	let {data,can_drag} = this.state
  	if (data.itemlist.length===0) {
			let col = showDiscount?8:6
			if (docType==='receiptvoucher')
				col = col+3
			else if (docType==='paymentvoucher')
				col = col+6	
			return(<tr><td colSpan={col}>{messages['Data Not Found']}</td></tr>)
		} else {
			if(showDragDrop){
				return data.itemlist.map((item,index)=> {
					return <DNDRowItem 
						key={index} 
						id={item.seq}
						item={item}
						can_drag={can_drag}
						moveRow={this.onMoveRow.bind(this)}
						renderColDetail={this.renderColDetail.bind(this,index)}
					/>
				})
			}else{
				return data.itemlist.map((item,index)=> {
					return (<tr key={index}>{this.renderColDetail(index,item)}</tr>)
				})
			}			
		}				
	}
	
	onMoveRow(id,afterId) {
    let {data} = this.state
    var rows = _.clone(data.itemlist);
    var currentRow = _.filter(rows, function (r) { return r.seq === id; })[0];
    var afterRow = _.filter(rows, function (r) { return r.seq === afterId; })[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data.itemlist = rows
    this.setState({data: data});
  }

  renderSelectVat() {
    let {messages} = this.props
    let No_Vat = messages['No Vat']
    let Vat_In = messages['Vat In']
    let Vat_Out = messages['Vat Out']
		let options = [{ "value": "in", "label": Vat_In },{ "value": "out", "label": Vat_Out },{ "value": "no", "label": No_Vat }]
		return(
  		<Row style={{marginBottom:'10px'}}>
  		  <Col md={10}></Col>		
	      <Col md={2}>
	      	{messages['Tax Type']}
	        <Select
                clearable={false}
                name="form-field-name"
                value={this.state.defaultVat}
                options={options}
                onChange={this.onVatChange.bind(this)}
            />
	      </Col>
      </Row>
  	)
	}

	renderSelectCustomerTypeModal() {
		let {showSelectCustomerType,customerType} = this.state
		let {messages} = this.props
		return(
			<Modal show={showSelectCustomerType} onHide={()=>{this.setState({showSelectCustomerType:false})}}>
        <Modal.Header closeButton>
          <Modal.Title>{messages['Select list']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					<Form>
						<FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Select type']} :</ControlLabel>
							&nbsp;
							<Radio
                  onChange={this.onCustomerTypeChange.bind(this,'customer')}
                  checked={customerType==='customer'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Customer2']}
              >
              </Radio>
							&nbsp;
							<Radio
                  onChange={this.onCustomerTypeChange.bind(this,'insurer')}
                  checked={customerType==='insurer'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Insurance']}
              >
              </Radio>
						</FormGroup>
					</Form>
        </Modal.Body>
        <Modal.Footer>
				  <Button bsStyle='primary' onClick={this.onCustomerTypeClick.bind(this)}><FontAwsome name='check' />&nbsp;{messages['Select']}</Button>
          <Button onClick={()=>{this.setState({showSelectCustomerType:false})}}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
        </Modal.Footer>
			</Modal>
		)	
	}

  render() {
		let {messages,docType} = this.props
		let {showDelConfirm,data,showInvoiceList,showPull,showPOList,showTaxList,showTable} = this.state
		const showVatType = (docType!=='receiptvoucher')
    return(
			<div>
				<div style={{display:showTable?'':'none'}}>
					<Box loading={false}>
						<Box.Header  className='text-center'>
							<Box.Title>
								{this.props.title} {messages['No.']} {this.state.docNo}              
							</Box.Title>
							<Box.Tools className='pull-right' >
								<Button className="bg-maroon btn" onClick={this.onPrintClick.bind(this)}><FontAwsome name='print' />&nbsp;{messages['Print Document']}</Button>
								&nbsp;
								{data.doc.seq_no!==''?
								<Button bsStyle='danger'                      
									onClick={()=>{this.setState({showDelConfirm:true})}}
								>
									<FontAwsome name='eraser'/>&nbsp;{messages['Delete Document']}
								</Button>    
								:''}
							</Box.Tools> 
						</Box.Header>
						<Box.Body>
							{this.renderHeaderRow()}
							{showVatType && this.renderSelectVat()}
							{this.renderTable()}
							{this.renderNewItemButton()}
							<br />
							<Row>
								{this.renderRemark()}
								{this.renderSummary()}
							</Row>	
						</Box.Body>
						<Box.Footer>
							<ButtonToolbar className='pull-right'>
								<Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>
								<Button onClick={this.onCloseClick.bind(this)}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
							</ButtonToolbar>
						</Box.Footer>
					</Box>
				</div>	
				<div style={{display:!showTable?'':'none'}}>
          <PurchaseOrderDoc ref='poDoc' onClose={this.onPODocClose.bind(this)}/>
        </div>
				<NotificationSystem ref="notificationSystem" />
        <IframeModal ref='iframe'  title={messages['Print Document']} /> 
				<ConfirmPopup
            show={showDelConfirm}
            onHide={()=>{this.setState({showDelConfirm:false})}}
            title={messages['Confirm']}
            message={messages['Confirm delete']}
            onConfirm={this.onDelClick.bind(this)}
        /> 
				<ConfirmPopup
            show={showPull}
            onHide={()=>{this.setState({showPull:false,pullType:''})}}
            title={messages['Confirm']}
            message={messages['Do you want to pull data']}
            onConfirm={this.onPullClick.bind(this)}
        /> 
				<InvoiceModal
					show={showInvoiceList}
					docType={docType}
					genItemlist={data.itemlist}
					customerName={data.doc.customer_name}
					onHide={()=>{this.setState({showInvoiceList:false})}}
					onSelect={this.onInvoiceSelect.bind(this)}
				/>
				<POModal
					show={showPOList}
					genItemlist={data.itemlist}
					customerName={data.doc.customer_name}
					onHide={()=>{this.setState({showPOList:false})}}
					onSelect={this.onPOSelect.bind(this)}
				/>
				<TaxinvoiceModal
					show={showTaxList}
					genItemlist={data.itemlist}
					tivNo={data.doc.taxinvoice_no}
					onHide={()=>{this.setState({showTaxList:false})}}
					onItemsSelect={this.onTaxinvoiceSelect.bind(this)}
				/>
				{this.renderSelectCustomerTypeModal()}
				<SupplierPageModal
					show={this.state.showSup}
					onHide={()=>{this.setState({showSup:false})}}
	        onSelect={this.onSupSelect.bind(this)}
				/>
			</div>	
    )
  }
}

GeneralDoc.defaultProps = {
  title: '',
  docType: '',
  docSName: '',
  docName: '',
  showDiscount: false,
  showDragDrop:false
}

export default GeneralDoc = connect(
	(state) => ({messages: state.message.view.doc.GeneralDoc}),null,null,{withRef:true}
)(GeneralDoc);    



// WEBPACK FOOTER //
// ./src/view/doc/GeneralDoc.js